import React, { Component } from 'react';
import { Button, Stack } from '@envoy/polarwind';
import Select from './components/Select';

class RuleReferenceMapping extends Component {

  state = { error: null };

  onRemove = () => {
    this.props.onRemove(this.props.index);
  };

  onChangeEnvoyRule = envoyRule => {
    const [action, table] = envoyRule.split('|');
    const { serviceNowColumnOptions, mapping } = this.props;
    const column = serviceNowColumnOptions.find(o => o.value === mapping.serviceNowColumn);
    if (column.reference !== table) {
      return this.setState({ error: 'The rule table does not match the reference table.' });
    }
    this.setState({ error: null });
    this.props.onChange({ ...this.props.mapping, envoyRule }, this.props.index);
  };

  onChangeServiceNowColumn = serviceNowColumn => {
    const { serviceNowColumnOptions, mapping } = this.props;
    const [action, table] = mapping.envoyRule.split('|');
    const column = serviceNowColumnOptions.find(o => o.value === serviceNowColumn);
    if (column.reference !== table) {
      return this.setState({ error: 'The rule table does not match the reference table.' });
    }
    this.setState({ error: null });
    this.props.onChange({ ...this.props.mapping, serviceNowColumn }, this.props.index);
  };

  render() {
    const { index, envoyRuleOptions, serviceNowColumnOptions, mapping } = this.props;
    return (
      <Stack>
        <div style={{textAlign: 'right', paddingTop: 23}}>
          <Button onClick={this.onRemove} plain>x</Button>
        </div>
        <div>
          <Select
            label="Envoy rule"
            options={envoyRuleOptions}
            value={mapping.envoyRule}
            onChange={this.onChangeEnvoyRule}
            required
          />
        </div>
        <div>
          <Select
            label="ServiceNow column"
            isSearchable={true}
            options={serviceNowColumnOptions}
            value={mapping.serviceNowColumn}
            onChange={this.onChangeServiceNowColumn}
            error={this.state.error}
            required
          />
        </div>
      </Stack>
    );
  }
}

export default RuleReferenceMapping;
